import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const SYNC_STATES = {
  idle: { color: 'rgba(255,255,255,0.15)', label: 'Not connected' },
  loading: { color: 'var(--color-macro-carbs)', label: 'Loading from cloud...' },
  saving: { color: 'var(--color-primary)', label: 'Saving...' },
  synced: { color: 'var(--color-success)', label: 'Synced' },
  error: { color: 'var(--color-danger)', label: 'Sync error' },
};

const Header = ({ user, syncStatus, sidebarOpen, toggleSidebar }) => {
  const sync = SYNC_STATES[syncStatus] || SYNC_STATES.idle;
  const navigate = useNavigate();
  const clickCount = useRef(0);
  const clickTimer = useRef(null);

  const handleLogoClick = () => {
    clickCount.current += 1;
    if (clickTimer.current) clearTimeout(clickTimer.current);
    if (clickCount.current >= 3) {
      clickCount.current = 0;
      navigate('/admin');
    } else {
      clickTimer.current = setTimeout(() => { clickCount.current = 0; }, 800);
    }
  };

  return (
    <header className="app-header" role="banner">
      <div className="header-brand">
        <button
          className="btn-sidebar-toggle"
          onClick={toggleSidebar}
          aria-label={sidebarOpen ? 'Close sidebar' : 'Open sidebar'}
          aria-expanded={sidebarOpen}
        >
          <span className="sidebar-toggle-bar" />
          <span className="sidebar-toggle-bar" />
          <span className="sidebar-toggle-bar" />
        </button>
        <span className="header-monogram" aria-hidden="true" onClick={handleLogoClick} style={{ cursor: 'default' }}>dP</span>
        <h1 className="header-title">de Partie</h1>
      </div>
      {user && (
        <div className="header-sync-indicator" title={sync.label}>
          <span
            className="header-sync-dot"
            style={{ background: sync.color }}
          />
          <span className="header-sync-label">{sync.label}</span>
        </div>
      )}
    </header>
  );
};

export default Header;
